import { render, staticRenderFns } from "./FoodMajorKindSelects.vue?vue&type=template&id=6624c1eb&"
import script from "./FoodMajorKindSelects.vue?vue&type=script&lang=js&"
export * from "./FoodMajorKindSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports